import React from 'react';
import FlightTakeoff from '@mui/icons-material/Flight';

export default function AbsenceBlock({absence, hideFullDayTimes = false}) {
  const sick = absence.type === 'sick-leave';
  const fullDay = absence.startTime === '00:00' && absence.endTime === '23:59';
  return <div title="Approved absence" style={{borderLeft: `4px solid ${sick ? '#f9a825' : '#356c92'}`,
    background: sick ? '#fff3c4' : '#e1f2f4', color: sick ? '#6b4f00' : '#356c92',
    borderRadius: 3, padding: 7, marginBottom: 4, fontSize: 12}}>
    <strong style={{display: 'flex', alignItems: 'center', gap: 4}}>
      <FlightTakeoff style={{transform: 'rotate(-45deg)', fontSize: 24}} />
      {sick ? 'Sick' : absence.label || 'Leave'}
    </strong>
    {absence.startTime && absence.endTime && !(hideFullDayTimes && fullDay) &&
      <div>{absence.startTime} – {absence.endTime}</div>}
  </div>;
}
